import _t from 'i18n!nls/front-page';

export const getPopularAndTrendingCollectionData = () => {
  return {
    headline: _t('Popular and trending courses'),
    collections: [
      {
        headline: _t('Most popular'),
        headlineTarget: '/explore/most-popular-courses',
        collection: {
          id: 'most-popular',
          collectionModuleId: 'most-popular-filter',
          collectionName: 'All',
          facets: [['topic:Business', 'topic:Data Science', 'topic:Information Technology', 'topic:Computer Science']],
        },
      },
      {
        headline: _t('Weekly spotlight'),
        headlineTarget: '/partners',
        collection: {
          id: 'trending-now',
          collectionModuleId: 'promo-template-preset-collection',
          presetCollectionId: 'UooUV9q7TxWuOqFbpsHCKQ',
        },
      },
      {
        headline: _t('In-demand AI skills'),
        headlineTarget: '/explore/generative-ai',
        collection: {
          id: 'in-demand-ai-skills',
          collectionModuleId: 'promo-template-preset-collection',
          presetCollectionId: 'ZEF0X29xSIOE_s-kixzF2Q',
        },
      },
    ],
  };
};

export const getPopularByCategoryCollectionData = () => {
  return {
    headline: _t('Most popular by category'),
    collections: [
      {
        headline: _t('Popular in Business'),
        headlineTarget: '/business',
        collection: {
          id: 'popular-in-business',
          collectionModuleId: 'most-popular-filter',
          collectionName: 'Business',
          facets: [['topic:Business']],
        },
      },
      {
        headline: _t('Popular in Data'),
        headlineTarget: '/data-science',
        collection: {
          id: 'popular-in-data',
          collectionModuleId: 'most-popular-filter',
          collectionName: 'Data Science',
          facets: [['topic:Data Science']],
        },
      },
      {
        headline: _t('Popular in Tech'),
        headlineTarget: '/computer-science',
        collection: {
          id: 'popular-in-tech',
          collectionModuleId: 'most-popular-filter',
          collectionName: 'Computer Science',
          facets: [['topic:Computer Science']],
        },
      },
    ],
  };
};
